import { IPaginationDTO, IPaginationResponse } from '@/models/pagination.model';
import { StepStatus, StepType } from '@/models/step.model';
import { IFullAddress } from '@/models/addresses.model';

export enum PropertyType {
  DETACHED_HOUSE = 'DETACHED_HOUSE',
  ATTACHED_HOUSE = 'ATTACHED_HOUSE',
  DUPLEX = 'DUPLEX',
  TOWNHOUSE = 'TOWNHOUSE',
  APARTMENT = 'APARTMENT',
  HOLIDAY_HOME = 'HOLIDAY_HOME',
}

export enum PropertiesEndpoints {
  ROOT = '/properties',
  PROPERTIES_SOLD = '/properties/sold',
  LIST = '/list',
  STATUS = '/status',
}

export enum PropertyStatus {
  ACTIVE = 'active',
  SOLD = 'sold',
}

export const staticPropertyEndpoints = {
  GET_PROPERTIES: `${PropertiesEndpoints.ROOT}${PropertiesEndpoints.LIST}`,
  GET_PROPERTIES_SOLD: PropertiesEndpoints.PROPERTIES_SOLD,
};

export const getPropertiesEndpoints = ({ propertyId }: { propertyId: string }) => ({
  GET_PROPERTY: `${PropertiesEndpoints.ROOT}/${propertyId}`,
});

export interface IProgressStep {
  step_name: StepType;
  status: StepStatus;
}

export interface IPropertyOwner {
  user_id: string;
  email: string;
  full_name: string;
  phone_number: string;
  invoice_address: IFullAddress;
}

export interface OwnershipShare {
  numerator: number;
  denominator: number;
}

export interface IPropertyCoowner {
  id: string;
  full_name: string;
  email: string;
  phone_number: string;
  ownership_share: OwnershipShare;
}

export interface IProperty {
  PK: string;
  SK: string;
  status: PropertyStatus;
  bedrooms: number;
  bra: number;
  user_email: string;
  user_name: string;
  address: IFullAddress;
  user_phone_number: string;
  created: string;
  modified: string;
  property_owner: IPropertyOwner;
  owners: IPropertyCoowner[];
  total_orders_sum: number;
  progress: IProgressStep[];
  property_type: PropertyType;

  knr: string;
  gnr: string;
  bnr: string;
  snr: string;
  fnr: string;
  is_housing_association: boolean;
  requires_extra_outdoor_appraisal: boolean;
  housing_association_share_id: string;
  housing_association_name: string;
  ownership_share: {
    numerator: number;
    denominator: number;
  };
  rooms: number;
  bathrooms: number;
  wc: number;
  floor: number;
  estimated_year_built: number;
  final_valuation_price?: number;
  final_sold_price?: number;
}

// ----------------- DTOs ----------------

export interface IGetPropertiesDTO extends IPaginationDTO {
  address?: string;
  cursor?: string;
  step_name?: StepType;
  type?: PropertyType;
  user_email?: string;
  user_phone_number?: string;
  total_orders_sum_gte?: string;
  owners?: string;
  progress?: string;
  established?: string;
  valuation_price_gte?: number;
  sold_price_gte?: number;
  limit?: number;
}

// ------------ Responses --------------

export interface IGetPropertiesResponse {
  items: IProperty[];
  cursor: IPaginationResponse;
  items_count: number;
}

export type IGetPropertyResponse = IProperty;
